import { Component, Inject } from "@angular/core";
import { AbstractControl, FormGroup } from "@angular/forms";

import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { LgdFormControlFactory } from "@tylertech/lgd-reactive-forms";

import { SafeHtml } from "@angular/platform-browser";

export interface PromptDialogData
{
    readonly title: string;
    readonly message: SafeHtml;
    readonly initialValue?: string;
    readonly okLabel?: string;
    readonly cancelLabel?: string;
}

@Component({
    selector: "prompt-dialog-component",
    templateUrl: "./prompt.tmpl.html",
    standalone: false
})
export class PromptDialogComponent
{
    readonly formGroup: FormGroup;

    comment: string;
    isProcessing: boolean;

    constructor(
        private readonly dialogRef: MatDialogRef<PromptDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private readonly data: PromptDialogData
    )
    {
        this.formGroup = new FormGroup({
            value: LgdFormControlFactory.text(this.data.initialValue, true)
        });
    }

    protected get control(): AbstractControl<string> { return this.formGroup.get("value"); }

    get title(): string { return this.data.title; }
    get message(): SafeHtml { return this.data.message; }
    get okLabel(): string { return this.data.okLabel ?? "OK"; }
    get cancelLabel(): string { return this.data.cancelLabel ?? "Cancel"; }

    close(): void
    {
        this.dialogRef.close(this.control.value);
    }

    cancel(): void
    {
        this.dialogRef.close();
    }
}
